import omniturePlugins from '../tracking-minified/omniturePlugins';
import {
    getSubscriptionInfo,
    getEntitlements
} from './subscription-helper';
import {
    validateMissingProperties,
    copyProps,
    findQueryParamCaseInsensitive,
    getAllQueryStringParams
} from './utils';
import getDelayedValues from './delayed-values';
import getGlobalContextVars from './global-context-vars';
import { parseProductArrayToString } from './tracking-helper';

const trackingConfig = window.espnTrackingConfig;
console.log('tracking-suite - trackingConfig:', trackingConfig);

const s_gi = window.s_gi; // eslint-disable-line camelcase
const Visitor = window.Visitor; // eslint-disable-line camelcase
let returnExport; //eslint-disable-line import/no-mutable-exports
window.pendingTracking = [];
// DSS data layer tracking props
let dssDataLayer = {
    pageName: 'Welcome - ESPN MLP',
    webAppName: 'espnplus', // this is how Analytics differentiates between D+ & E+
    // linkId: 'buy:espn+monthly:7ft',
    // product: 'D2C;8400199910209919951899000',
    // promoCode: 'promocode20',
    // purchaseMethod: 'google',
    // subscriberType: 'active',
    // entitlements: 'ESPN_PLUS_MLB',
    // buyLocation: 'espnplus:landingpage:buy',
    // externalMkt: 'ex_cid=DSS-Search-Google-71700000034270488',
    // navMethod: 'topnav'
    om: {}
};

const {
    trackingTitle,
    languageLocale,
    adobeAnalytics,
    disneyAdobeAnalytics,
    espnTrackingEnabled,
    disneyTrackingEnabled
} = trackingConfig;

const createAdobeTrackingSuiteInstance = function (analyticsConfig) {
    const {
        reportingSuiteId,
        trackingServer,
        trackingServerSecure
    } = analyticsConfig;

    const s = s_gi(reportingSuiteId);
    omniturePlugins.loadPlugins(s);
    s.linkInternalFilters = 'javascript:,espn.go.com,espn.com,jayski.com,cricinfo.com,scrum.com,nasn.com,espnclassicsport.com,espnshop.com,espn360.com,horseracing.com,expn.go.com,expn.com,espntv.com,myespn.go.com,starwave.com,x.go.com,soccernet.com,soccernet.fr,soccernet.es,soccernet.it,soccernet.de,espndeportes.com,espndeportes.fr,espndeportes.es,espndeportes.it,espndeportes.de,spanishflytv.com,redfishcup.com,espnclassic.com,racing-live.com,quiznosmadfin.com,collegebass.com,espnamerica.com,espnstar.com,espndb.go.com,espn.co.uk,shop.expn.com,grantland.com,espnpub01,espnmast01,vwtsbar02,b.espncdn.com,espncdn.com,a.espncdn.com,fantasybeta.espn.go.com,espn-ffl-2013-stage.sportsr.us,espn-ffl-2013.sportsr.us,espnsync.com,espnfivethirtyeight.wordpress.com,fivethirtyeight.com,projects.fivethirtyeight.com,espn.com.mx,espn.com.ar,espn.com.ve,espn.com.co,espnfc.com,espnfc.us,espnfc.co.uk,espnfc.mx,espnfc.com.ar,espnfc.com.ve,espnfc.com.co,espnfc.com.br,espnfc.com.ng,espnfc.com.sg,espnfc.com.au,espnfc.com.my,espnfc.co.id,secsports.go.com,secsports.com,secsports.com,espn.uol.com.br,espnplayer.com,footytips.com.au,espn.com.au,espnview.com.au,espn.cl,espnfcasia.com,sonyespn.com,espn.in,kwese.espn.com,espn-development.com'; //eslint-disable-line no-script-url, max-len

    s.trackingServer = trackingServer;
    s.trackingServerSecure = trackingServerSecure;

    return s;
};

const getVisitorInstance = function (analyticsConfig) {
    const {
        marketingCloudId,
        trackingServer,
        trackingServerSecure
    } = analyticsConfig;

    const visitorInstance = Visitor.getInstance(marketingCloudId, {
        trackingServer,
        trackingServerSecure
    });

    return visitorInstance;
};

/**
 *
 * Track Page View
 * @desc Function used for async tracking like user clicks.
 *
 */

const trackPageView = function () {
    const s = createAdobeTrackingSuiteInstance(adobeAnalytics);
    const disneyPixel = createAdobeTrackingSuiteInstance(disneyAdobeAnalytics);

    const setTrackingValues = function (trackingObj, analyticsConfig) {
        trackingObj.visitor = getVisitorInstance(analyticsConfig);
        const {
            sectionAdobeAnalyticsContextData,
            pageAdobeAnalyticsContextData,
            adobeAnalyticsContextData
        } = trackingConfig;
        // s.trackDownloadLinks = true;
        // s.trackExternalLinks = true;
        // s.trackInlineStats = true;
        // s.linkDownloadFileTypes = 'exe,zip,wav,mp3,mov,mpg,avi,wmv,pdf,doc,docx,xls,xlsx,ppt,pptx';
        // // eslint-disable-next-line no-script-url

        // s.linkLeaveQueryString = false;
        // s.linkTrackVars = 'None';
        // s.linkTrackEvents = 'None';

        // bring in section analytics overrides - if they exist
        if (sectionAdobeAnalyticsContextData) {
            trackingObj.contextData =
                Object.assign({}, trackingObj.contextData, sectionAdobeAnalyticsContextData);
        }

        // bring in page analytics overrides - if they exist
        if (pageAdobeAnalyticsContextData) {
            trackingObj.contextData =
                Object.assign({}, trackingObj.contextData, pageAdobeAnalyticsContextData);
        }

        // bring in response analytics overrides - if they exist
        if (adobeAnalyticsContextData) {
            trackingObj.contextData =
                Object.assign({}, trackingObj.contextData, adobeAnalyticsContextData);
        }

        const allPromises = [getGlobalContextVars(s), getDelayedValues(trackingConfig)];

        Promise.all(allPromises).then(([context, delayedValues]) => {
            // copy the context data into the omniture analytics contextData
            if (context) {
                copyProps(context, trackingObj.contextData);
            }

            if (delayedValues) {
                const pageName = delayedValues.pageName || 'Welcome - ESPN MLP';
                trackingObj.pageName = pageName;
                trackingObj.products = delayedValues.product;
                dssDataLayer.pageName = pageName;
                copyProps(delayedValues.contextData, dssDataLayer);
            }

            // If the optimizely custom integration is hooked up use it
            const optimizelyIntegration = window.optimizely &&
                typeof window.optimizely.get === 'function' &&
                window.optimizely.get('custom/adobeIntegrator');
            if (optimizelyIntegration && optimizelyIntegration.assignCampaigns) {
                optimizelyIntegration.assignCampaigns(trackingObj);
            }

            // This is the actual omniture tracking pageview call
            trackingObj.t();
            // delay sending optimizely events until we get all tracking data needed
            // and fire optimizely events along with adobe to avoid discrepancies
            window.optimizely.push({ type: 'sendEvents' });
        }).catch((err) => {
            console.error('Error gathering analytics data', err);
        });
    };

    if (espnTrackingEnabled) {
        setTrackingValues(s, adobeAnalytics);
    }

    if (disneyTrackingEnabled) {
        setTrackingValues(disneyPixel, disneyAdobeAnalytics);
    }
};

/**
 *
 * Track Async.
 *
 * @desc Function used for async tracking like user clicks.
 * @param asyncContextDataObj
 * @param defaultPropsToRemove
 *
 */
const trackAsync = function (defaultPropsToRemove) {
    const s = createAdobeTrackingSuiteInstance(adobeAnalytics);
    const disneyPixel = createAdobeTrackingSuiteInstance(disneyAdobeAnalytics);
    const buttonData = $(this).data();
    const trackingProps = JSON.parse(decodeURIComponent(buttonData.tracking || '{}'));
    // trackingScript is set in dataHelper on wysiwyg buttons when triggering oneid script
    // loginSuccessUrl is set on the front end when need to fire oneId script on non-wysiwyg buttons
    trackingProps.ctaButtonURL = buttonData.trackingScript || buttonData.loginSuccessUrl || this.href || '';
    trackingProps.ctaButtonCopy = this.innerText.trim();
    trackingProps.module = buttonData.trackingModuleType || '';

    return new Promise((resolve) => {
        Promise.all([
            getGlobalContextVars(s, defaultPropsToRemove),
            getGlobalContextVars(disneyPixel, defaultPropsToRemove)
        ])
            .then(([globalContextData, disneyGlobalContextData]) => {
                return new Promise((resolve2) => {

                    const setTrackingValues = function (trackingObj) {
                        return new Promise((resolve3) => {
                            // Omniture trackAsync will need some due diligence on being fleshed out.
                            // https://wiki.mlbam.com/display/ANA/.OMN302%3A+Actual+Code+Examples
                            // https://marketing.adobe.com/resources/help/en_US/sc/implement/function_tl.html

                            const linkTrackVars = [];
                            trackingObj.clearVars();
                            trackingObj.contextData = {};
                            const {
                                ctaButtonURL,
                                ctaButtonCopy,
                                contextData
                            } = trackingProps;

                            let {
                                products,
                                module
                            } = trackingProps;

                            const asyncContextData = { ctaButtonCopy, ctaButtonURL, ...contextData };

                            // move products up to s instead of contextData
                            if (products) {
                                products = parseProductArrayToString(products);
                                trackingObj.products = products;
                            }

                            let linkname = 'https://plus.espn.com';
                            /*
                                linkname = linkid and is dynamic, based on the location of the button on the page:
                                Navigation, Hero, Body (features section), Footer
                                Example: Welcome - MLP: Navigation Click
                            */
                            module = module ? ` : ${module} Click` : '';

                            // linkname is what is being read as an "action"
                            linkname = `${((dssDataLayer && dssDataLayer.pageName) || trackingObj.pageName)}${module}`;
                            asyncContextData.linkid = linkname;
                            asyncContextData.action = linkname;

                            // props taken from page load
                            copyProps(globalContextData, trackingObj.contextData);

                            copyProps(asyncContextData, trackingObj.contextData);

                            // Set s.linkTrackVars as comma-delimited string with all context data vars,
                            // prefix each with 'contextData.'
                            for (const prop in trackingObj.contextData) {
                                if (trackingObj.contextData[prop] !== null) {
                                    linkTrackVars.push(`contextData.${prop}`);
                                }
                            }

                            linkTrackVars.push('products');
                            trackingObj.linkTrackVars = linkTrackVars.join();

                            // Track what actions are being fired
                            window.pendingTracking.push(asyncContextData);

                            // async call
                            trackingObj.tl(true, 'o', linkname, null, () => {
                            // Delete once the request has being made
                                window.pendingTracking = window.pendingTracking.filter((item) => {
                                    return item !== asyncContextData;
                                });
                                resolve3();
                            });
                        });
                    };

                    const trackingPromises = [];
                    if (espnTrackingEnabled) {
                        trackingPromises.push(setTrackingValues(s, globalContextData));
                    }

                    if (disneyTrackingEnabled) {
                        trackingPromises.push(setTrackingValues(disneyPixel, disneyGlobalContextData));
                    }
                    // if the s.tl above isn't fast enough - don't stall the navigation any longer.
                    setTimeout(resolve2, 1000);
                    return Promise.all(trackingPromises)
                        .then(resolve2)
                        .catch(resolve2);
                });
            }).catch((err) => {
                console.error('Tracking error', err);
            }).then(resolve);
    });
};

if (!s_gi || !Visitor) { // eslint-disable-line camelcase
    returnExport = {
        trackPageView() {
            console.warn('trackPageView - not actually run, possibly caused by ad/tracking blocker');
        },
        trackAsync() {
            console.warn('trackAsync - not actually run, possibly caused by ad/tracking blocker');
            return Promise.reject(new Error('No adobe tracking lib loaded'));
        }
    };
} else {
    // config validation
    validateMissingProperties({ trackingTitle, languageLocale, ...adobeAnalytics });
    validateMissingProperties({ trackingTitle, languageLocale, ...disneyAdobeAnalytics });

    // add tracking items from homebase stored in pageConfig
    if (trackingConfig.pageAdobeAnalyticsContextData) {
        dssDataLayer = Object.assign({}, dssDataLayer, trackingConfig.pageAdobeAnalyticsContextData);
    }

    // add any items from query string
    [
        ['addata', 'internalmkt'],
        ['ex_cid', 'externalmkt']
    ].forEach((queryParam) => {
        const pramValue = findQueryParamCaseInsensitive(queryParam[0]);
        if (pramValue !== false) {
            dssDataLayer[queryParam[1]] = pramValue;
        }
    });

    // add omniture values and internal dss values
    const queryStringParams = getAllQueryStringParams();
    Object.keys(queryStringParams).forEach((key) => {
        if (key.indexOf('om-') === 0) {
            dssDataLayer.om[key.substr(3)] = queryStringParams[key];
        }
    });

    // track subscription info
    getSubscriptionInfo().then((subscriptionInfo) => {
        dssDataLayer.purchaseMethod = subscriptionInfo.purchaseMethod;
        dssDataLayer.subscriberType = subscriptionInfo.subscriptionType;
    });

    // track entitlements
    const noEntitlementFallback = 'no entitlements';
    getEntitlements(noEntitlementFallback).then((entitlements) => {
        dssDataLayer.entitlements = entitlements || noEntitlementFallback;
    });

    window.dssDataLayer = dssDataLayer;
    // placing on the window so other modules can call `btmTracking.trackAsync(...)`
    returnExport = {
        _getGlobalContextVars: getGlobalContextVars,
        trackPageView,
        trackAsync,
        dssDataLayer
    };
}
window.btmTracking = returnExport;
export default returnExport;
